<p-confirmDialog key="reminder" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="reminderconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div style="background-color: #ffffff">
	<!--School Select-->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<caass-schoolselector [ShowAll]="false" [Disabled]="loading"> </caass-schoolselector>
			</div>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add Reminder</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">Edit Reminder</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onCopy()">Copy Reminder</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onToggle()">
			{{ ToggleText }}
		</button>
		<button class="btn btn-danger" style="margin-left: 5px" (click)="onDelete()">Delete Reminder</button>
		<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />

		<label class="TitleLabel">Reminders</label>
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="ShowInfo == true ? 'block' : 'none'">
		<label>&#9900; Add Reminder: Create a new reminder. Select it and use the bottom table to assign students and staff</label><br />
		<label>&#9900; Edit Reminder: Update a reminder's properties</label><br />
		<label>&#9900; Copy Reminder: Create a new reminder based on an existing one. NOTE: this will also copy all of the students to the new reminder</label
		><br />
		<label
			>&#9900; Toggle Reminder: Toggle whether or not a reminder is displayed in ScanStation. Inactive reminders won't play for any of the assigned
			students whether they are active or not. Deactivating a reminder will keep the list of students and whether or not they received the reminder.
			Deleting a reminder will hide that data</label
		><br />
		<label>&#9900; Delete Reminder: Delete a reminder that is no longer used. </label><br />
		<br />
		<label>Table Columns:</label><br />
		<label
			>&#9900; Type: When will the reminder display. The options are: Play Once (Each student only sees it one time then it goes away, or it can be
			deactivated before displaying), Play Until Removed (Plays until either the reminder is deactivated for everyone in this table or it is deactivated
			for that student in the bottom table), Date Range (Plays during the date range or you can stop it early by deactivating it)</label
		><br />
		<label>&#9900; Active: Whether or not the reminder will play for any of the assigned people.</label><br />
		<label
			>&#9900; Entry, Exit, etc.: The last 7 columns that have checks or x's show which ScanStation modes will display the reminders. You can set up
			reminders that will only display in certain modes ex. Entry Mode Only reminder that says "Homeroom 105 report to room 206 today." </label
		><br />
		<br />
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstStationReminderAlert"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedStationReminderAlert"
		dataKey="StationReminderAlertID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--Message-->
				<th>
					<p-columnFilter type="text" field="Message" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--AlertTypeDesc-->
				<th class="OccurColumn">
					<p-columnFilter field="AlertTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterAlertTypeDesc
								[ngModel]="value"
								[options]="lstAlertTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--StartDate-->
				<th class="DateColumn">
					<!-- <p-columnFilter type="text" field="StartDate" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--EndDate-->
				<th class="DateColumn">
					<!-- <p-columnFilter type="text" field="EndDate" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--SoundFile-->
				<th>
					<p-columnFilter type="text" field="SoundFile" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--PersonCount-->
				<th>
					<!-- <p-columnFilter type="text" field="PersonCount" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--c_date-->
				<th>
					<!-- <p-columnFilter type="text" field="c_date" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--PriorityDesc-->
				<th>
					<p-columnFilter field="PriorityDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPriorityDesc
								[ngModel]="value"
								[options]="lstPriorityDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th class="ActiveColumn">
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--EntryModeDesc-->
				<th class="CheckColumn">
					<!-- <p-columnFilter field="EntryModeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterEntryModeDesc [ngModel]="value" [options]="lstEntryModeDesc" (onChange)="filter($event.value)"
								placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{value}}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter> -->
				</th>

				<!--ExitModeDesc-->
				<th class="CheckColumn">
					<!-- <p-columnFilter field="ExitModeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterExitModeDesc [ngModel]="value" [options]="lstExitModeDesc" (onChange)="filter($event.value)"
								placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{value}}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter> -->
				</th>

				<!--MealModeDesc-->
				<th class="CheckColumn">
					<!-- <p-columnFilter field="MealModeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterMealModeDesc [ngModel]="value" [options]="lstMealModeDesc" (onChange)="filter($event.value)"
								placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{value}}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter> -->
				</th>

				<!--AccessModeDesc-->
				<th class="CheckColumn">
					<!-- <p-columnFilter field="AccessModeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterAccessModeDesc [ngModel]="value" [options]="lstAccessModeDesc" (onChange)="filter($event.value)"
								placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{value}}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter> -->
				</th>

				<!--TimeStampModeDesc-->
				<th class="CheckColumn">
					<!-- <p-columnFilter field="TimeStampModeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterTimeStampModeDesc [ngModel]="value" [options]="lstTimeStampModeDesc" (onChange)="filter($event.value)"
								placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{value}}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter> -->
				</th>

				<!--EventEntryModeDesc-->
				<th class="CheckColumn">
					<!-- <p-columnFilter field="EventEntryModeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterEventEntryModeDesc [ngModel]="value" [options]="lstEventEntryModeDesc" (onChange)="filter($event.value)"
								placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{value}}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter> -->
				</th>

				<!--EventExitModeDesc-->
				<th class="CheckColumn">
					<!-- <p-columnFilter field="EventExitModeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterEventExitModeDesc [ngModel]="value" [options]="lstEventExitModeDesc" (onChange)="filter($event.value)"
								placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{value}}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter> -->
				</th>

				<!--ParentPortalSendNotification-->
				<th class="CheckColumn"></th>

				<!--StudentPortalSendNotification-->
				<th class="CheckColumn"></th>

				<!--StaffPortalSendNotification-->
				<th class="CheckColumn"></th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="Message">Message<p-sortIcon field="Message"></p-sortIcon></th>
				<th class="OccurColumn" pSortableColumn="AlertTypeDesc">Type<p-sortIcon field="AlertTypeDesc"></p-sortIcon></th>
				<th class="DateColumn" pSortableColumn="StartDate">Start Date<p-sortIcon field="StartDate"></p-sortIcon></th>
				<th class="DateColumn" pSortableColumn="EndDate">End Date<p-sortIcon field="EndDate"></p-sortIcon></th>
				<th pSortableColumn="SoundFile">Sound File<p-sortIcon field="SoundFile"></p-sortIcon></th>
				<th pSortableColumn="PersonCount">Person Count<p-sortIcon field="PersonCount"></p-sortIcon></th>
				<th pSortableColumn="c_date">Last Updated<p-sortIcon field="c_date"></p-sortIcon></th>
				<th pSortableColumn="PriorityDesc">Priority<p-sortIcon field="PriorityDesc"></p-sortIcon></th>
				<th class="ActiveColumn" pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>

				<th class="CheckColumn" pSortableColumn="EntryMode">Entry<p-sortIcon field="EntryMode"></p-sortIcon></th>
				<th class="CheckColumn" pSortableColumn="ExitMode">Exit<p-sortIcon field="ExitMode"></p-sortIcon></th>
				<th class="CheckColumn" pSortableColumn="MealMode">Meal<p-sortIcon field="MealMode"></p-sortIcon></th>
				<th class="CheckColumn" pSortableColumn="AccessMode">Access<p-sortIcon field="AccessMode"></p-sortIcon></th>
				<th class="CheckColumn" pSortableColumn="TimeStampMode">Time Stamp<p-sortIcon field="TimeStampMode"></p-sortIcon></th>
				<th class="CheckColumn" pSortableColumn="EventEntryMode">Event Entry<p-sortIcon field="EventEntryMode"></p-sortIcon></th>
				<th class="CheckColumn" pSortableColumn="EventExitMode">Event Exit<p-sortIcon field="EventExitMode"></p-sortIcon></th>
				<th class="CheckColumn" pSortableColumn="ParentPortalSendNotification">
					Notify Parents<p-sortIcon field="ParentPortalSendNotification"></p-sortIcon>
				</th>
				<th class="CheckColumn" pSortableColumn="StudentPortalSendNotification">
					Notify Student<p-sortIcon field="StudentPortalSendNotification"></p-sortIcon>
				</th>
				<th class="CheckColumn" pSortableColumn="StaffPortalSendNotification">
					Notify Staff<p-sortIcon field="StaffPortalSendNotification"></p-sortIcon>
				</th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-StationReminderAlert>
			<tr [pSelectableRow]="StationReminderAlert" (dblclick)="onRowDblClick(StationReminderAlert)">
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="StationReminderAlert.MessageFontColor">
					{{ StationReminderAlert.Message }}
				</td>

				<td class="OccurColumn" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ StationReminderAlert.AlertTypeDesc }}
				</td>

				<td class="DateColumn" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ StationReminderAlert.StartDateDesc }}
				</td>

				<td class="DateColumn" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ StationReminderAlert.EndDateDesc }}
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ StationReminderAlert[col.field] }}
				</td>

				<td
					class="ActiveColumn"
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="StationReminderAlert.Active == true ? 'Black' : 'Red'"
				>
					{{ StationReminderAlert.ActiveDesc }}
				</td>

				<td class="CheckColumn" *ngFor="let col of ModeCols">
					<i *ngIf="StationReminderAlert[col.field] == true" class="pi pi-check-circle active-color IconFont"></i>
					<i *ngIf="StationReminderAlert[col.field] == false" class="pi pi-ban inactive-color IconFont"></i>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
